module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"about":"О компании","vacancies":"Вакансии"}}')
  delete Component.options._Ctor
}
